var _rect, _rect2, _circle, _line, _text, _rect3, _circle2, _line2, _text2, _rect4, _circle3, _line3, _text3, _rect5, _circle4, _line4, _text4, _rect6, _circle5, _line5, _text5, _rect7, _circle6, _line6, _text6, _rect8, _circle7, _line7, _text7, _rect9, _circle8, _line8, _text8, _rect0, _circle9, _line9, _text9, _rect1, _circle0, _line0, _text0, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZonesEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 152",
    fontFamily: "sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 48,
    height: 96,
    fill: "#1f7a3a",
    stroke: "#fff",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 104.6,
    width: 27.8,
    height: 15.4,
    fill: "rgba(255,255,255,0.12)",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 112.3,
    r: 0.9,
    fill: "#ffd54a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 112.3,
    x2: 106,
    y2: 122,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 126,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "middle"
  }, "My box")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 72,
    width: 27.8,
    height: 32.6,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 88.3,
    r: 0.9,
    fill: "#ffd54a"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 88.3,
    x2: 79,
    y2: 95,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 97,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "end"
  }, "My centre")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 39.4,
    width: 27.8,
    height: 32.6,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 55.7,
    r: 0.9,
    fill: "#ffd54a"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 55.7,
    x2: 133,
    y2: 49,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 51,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "start"
  }, "Opp. centre")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1,
    y: 24,
    width: 27.8,
    height: 15.4,
    fill: "rgba(255,255,255,0.12)",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 31.7,
    r: 0.9,
    fill: "#ffd54a"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 31.7,
    x2: 106,
    y2: 22,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 20,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "middle"
  }, "Opp. box")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 87.8,
    width: 10.1,
    height: 32.2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 103.9,
    r: 0.9,
    fill: "#ffd54a"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 103.9,
    x2: 79,
    y2: 103.9,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 105.9,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "end"
  }, "Left def.")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 56.2,
    width: 10.1,
    height: 31.7,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 72,
    r: 0.9,
    fill: "#ffd54a"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 72,
    x2: 79,
    y2: 72,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 74,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "end"
  }, "Left mid")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 24,
    width: 10.1,
    height: 32.2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 40.1,
    r: 0.9,
    fill: "#ffd54a"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: 40.1,
    x2: 79,
    y2: 40.1,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 42.1,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "end"
  }, "Left att.")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 87.8,
    width: 10.1,
    height: 32.2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 103.9,
    r: 0.9,
    fill: "#ffd54a"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 103.9,
    x2: 133,
    y2: 103.9,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 105.9,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "start"
  }, "Right def.")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 56.2,
    width: 10.1,
    height: 31.7,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 72,
    r: 0.9,
    fill: "#ffd54a"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 72,
    x2: 133,
    y2: 72,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 74,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "start"
  }, "Right mid")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 24,
    width: 10.1,
    height: 32.2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.4,
    strokeDasharray: "1.5 1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 40.1,
    r: 0.9,
    fill: "#ffd54a"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 40.1,
    x2: 133,
    y2: 40.1,
    stroke: "#ffd54a",
    strokeWidth: 0.4
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 42.1,
    fill: "#fff",
    fontSize: 6.5,
    textAnchor: "start"
  }, "Right att.")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 133,
    fill: "#888",
    fontSize: 4.2,
    textAnchor: "middle"
  }, "\u2193 your goal    \u2191 opponent goal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonesEn);
export default __webpack_public_path__ + "static/media/zones-en.c87a5f5a39ba32512601d09957a70a3d.svg";
export { ForwardRef as ReactComponent };